import { genComponentStyleHook, type FullToken } from './styleUtil'
import { getBorderStyle } from './gradientUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Card', 'techTheme'], (token: FullToken) => {
  const { componentCls, lineWidth } = token
  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      '&:before': getBorderStyle(lineWidth),
      [`${componentCls}-head`]: {
        position: 'relative',
        '&:before': [
          ...getBorderStyle(lineWidth),
          { transition: 'none' },
        ],
      },
    },
  }
})
